import Axios from 'axios'

export const JewelHistoryType = {
  ACQUIRE: 'acquire',
  EXCHANGE: 'exchange',
  EXPIRE: 'expire',
  COIN_EXCHANGE: 'coin_exchange'
}

class Api {
  async getServerConstsnts () {
    const response = await Axios.get('/jewel_exchange/server_constants')

    return {
      exchangeStep: response.data.server_constants.exchange_step,
      leastRequiredJewelToExchange: response.data.server_constants.least_required_jewel_to_exchange
    }
  }
  async getCurrentUserInfo () {
    const response = await Axios.get('/jewel_exchange/self')

    const user = response.data.user

    return {
      id: user.id,
      jewelBalance: user.jewel,
      isBelongingToAgency: user.is_belonging_to_agency,
      twitterId: user.twitter_id
    }
  }
  async getJewelHistories () {
    const response = await Axios.get('/jewel_exchange/jewel_histories')

    return response.data.log_jewel_journals.map((history) => ({
      id: history.id,
      difference: history.difference,
      type: (() => {
        switch (history.transaction_type) {
          case 'acquire':
          case 'transaction_type_acquire':
            return JewelHistoryType.ACQUIRE
          case 'exchange':
          case 'transaction_type_exchange':
            return JewelHistoryType.EXCHANGE
          case 'expire':
          case 'transaction_type_expire':
            return JewelHistoryType.EXPIRE
          case 'coin_exchange':
          case 'transaction_type_coin_exchange':
            return JewelHistoryType.COIN_EXCHANGE
          default:
            return null
        }
      })(),
      exchangedAt: history.log_jewel_exchange_request && history.log_jewel_exchange_request.exchanged_at ? new Date(history.log_jewel_exchange_request.exchanged_at) : null,
      calculationForDate: history.log_jewel_calculation ? new Date(history.log_jewel_calculation.for_date) : null,
      datetime: new Date(history.created_at)
    }))
  }
  async postExchangeRequest ({ requestUUID, amount }) {
    const result = await Axios.post('/jewel_exchange/exchange_requests', {
      request_id: requestUUID,
      amount
    })

    return result.data
  }
}

const instance = new Api()
export default instance
